var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSocialTwitch = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.496 9.187-2.763 2.753H9.971l-2.417 2.409v-2.41H4.446V1.616h11.05v7.572Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.755.239.302 3.68v12.39h4.143v3.442L7.9 16.07h2.762l6.216-6.195V.24H3.755Zm11.74 8.948-2.762 2.753H9.97l-2.417 2.41v-2.41H4.445V1.615h11.05v7.572Z",
    fill: "#9146FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.424 4.024h-1.381v4.13h1.381v-4.13Z",
    fill: "#9146FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.626 4.024H8.245v4.13h1.38v-4.13Z",
    fill: "#9146FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.575,
    height: 19.273,
    fill: "#fff",
    transform: "translate(.302 .239)"
  })))));
};

export { SvgSocialTwitch as ReactComponent };